import React from 'react';
import { Spin } from 'antd';
import Styles from './LoadingOverlay.module.scss';

interface LoadingOverlayProps {
    /** Loading message/tip */
    tip?: string;
    /** Size of the spinner */
    size?: 'small' | 'default' | 'large';
    /** Background opacity (0-1) */
    opacity?: number;
    /** Z-index */
    zIndex?: number;
    /** Custom className */
    className?: string;
}

/**
 * Reusable loading overlay component with absolute positioning
 */
export default function LoadingOverlay({
    tip,
    size = 'large',
    opacity = 0.8,
    zIndex = 10,
    className,
}: LoadingOverlayProps) {
    const containerClass = `${Styles.overlay} ${className || ''}`.trim();
    const backgroundColor = `rgba(255, 255, 255, ${opacity})`;

    return (
        <div
            className={containerClass}
            style={{
                backgroundColor,
                zIndex,
            }}
        >
            <Spin
                size={size}
                tip={tip}
            />
        </div>
    );
}
